import { useRef, useCallback, useEffect } from "react";

/**
 * Devuelve una función debounced que se recrea solo si cambia `fn` o `delay`.
 */
export function useDebouncedCallback<T extends (...args: any[]) => void>(
  fn: T,
  delay: number
) {
  const timeoutRef = useRef<NodeJS.Timeout>();

  const debounced = useCallback(
    (...args: Parameters<T>) => {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => fn(...args), delay);
    },
    [fn, delay]
  );

  // Cleanup
  useEffect(() => {
    return () => clearTimeout(timeoutRef.current);
  }, []);

  return debounced;
}
